import type { BasketOfferItem } from '@ori-events/add-basket-offer';
import * as AddBasketOfferFailed from '@ori-events/add-basket-offer-failed';
import type { PositionData } from '@ori/analytics-data';

import type { AddBasketOfferResponse } from '../guards/addBasketOfferResponse';
import { isAddBasketOfferErrorResponse } from '../guards/addBasketOfferResponse';
import type { RequestUrl } from '../models';
import { RequestMethod } from '../models';
import { convertToCamelCase } from './convertToCamelCase';
import { getHttpRequestSettings } from './getHttpRequestSettings';

interface AddBasketOfferApplyParams extends PositionData {
  offerId: number;
}

interface AddBasketOfferPurchaseParams extends PositionData {
  choiceId: number;
  items: BasketOfferItem[];
}

export const addBasketOffer = async (
  url: RequestUrl.AddBasketOffer | RequestUrl.PurchaseBasketOffer,
  params: AddBasketOfferApplyParams | AddBasketOfferPurchaseParams,
) => {
  const request = await fetch(url, getHttpRequestSettings(params, RequestMethod.Post));

  const response = convertToCamelCase<AddBasketOfferResponse>((await request.json()) as object);

  if (isAddBasketOfferErrorResponse(response)) {
    const event = new CustomEvent<AddBasketOfferFailed.Data>(AddBasketOfferFailed.Name, {
      detail: response,
    });
    window.dispatchEvent(event);

    return false;
  }

  return response;
};
